import React from 'react';
import store, { templatesAction } from '@apply/adminStore';
import { SectionHeader } from '../common/SharedComponents';
import { TemplateType, TemplateTypeOptions } from '@apply/constants';
import { TemplatesTable } from './tables/TemplatesTable';
import EditTemplateModal from './modals/EditTemplateModal';
import EditNotesModal from './modals/EditNotesModal';
import EditNameModal from './modals/EditNameModal';
import { BfiCustomStore } from '../common/SharedComponents';

function TablesPage({ templateTypeId }) {
    const { dispatch } = store;

    const onAdd = () => {
        dispatch(
            templatesAction.setEditTemplateModal({
                editTemplateModal: {
                    isOpen: true,
                    templateId: 0,
                    categoryId: templateTypeId,
                },
            })
        );
    };

    const getHeader = () => {
        var option = TemplateTypeOptions.find((t) => t.id === templateTypeId);
        return option?.name ?? 'Templates';
    };

    return (
        <>
            <SectionHeader
                title={getHeader()}
                buttonText={parseInt(templateTypeId) === TemplateType.ICCA ? 'Add New' : null}
                buttonCallback={() => onAdd()}
            />
            <div
                className='main-content'
                style={{ padding: 0, backgroundColor: '#f4f4f4' }}
            >
                <div
                    className='loans scrollable-content'
                    style={{ padding: '1 rem' }}
                >
                    <div
                        className='templates accordion'
                        data-accordion=''
                        data-allow-all-closed='true'
                        data-multi-expand='true'
                    >
                        <div className='card'>
                            <div className='card-section'>
                                <TemplatesTable templateTypeId={templateTypeId} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <EditTemplateModal />
            <EditNotesModal />
            <EditNameModal />
        </>
    );
}

export default TablesPage;
